/* eslint-disable no-console */
import JQuery from 'jquery'
let $ = JQuery

/************************************************************************************************************************************************************************
 * à l'attention du développeur qui reprendra ce code : 
 * 
 * nous en sommes à la Xeme version sur X projets : avec à chaque fois des demandes et des changements loufoques et non réfléchis
 * le code est purement imbouffable, je m'autoHack en permanence 
 * les versions d'avant n'avaient pas la notion de quartier avec un bâtiment à choisir 
 * Etant donné que tout est en Vue JS et qu'il était "trop long de repartir de 0" ou même de transformer cette appli en component Vue, voici le tas de rustines.
 * (en gros c'est juste un proto fonctionnel auquel on m'a demandé de rajouter des features sans avoir réfléchi aux conséquences ni au code)
 * 
 * le Json généré par la 3d a été maintes fois modifié, des infos ont été ajoutées, d'autres sont obsolètes. Il doit subsister un tas d'erreurs et d'incohérences
 * 
 * Conseil avisé : repartir d'un projet tout propre.
 * 
 * Merci & désolé
 ************************************************************************************************************************************************************************/

//var internalThis = null;

export default class okanMainClass{
    constructor(){
        //this.context=context;

        this.leftMouseButtonDown = false;
        this.mouseX = 0;
        this.mouseY = 0;

        this.UI = null;

        this.jsonData = null;
        this.canvas = null;
        this.quaterCanvas = null;
        this.quarterOverlay = null;
        this.context = null;
        this.quaterContext = null;
        this.overlayContext = null;
        this.canvasWidth = 0;
        this.canvasHeight = 0;
        this.canvasTop = 0;
        this.canvasLeft = 0;

        this.hoveredColor = null;
        this.hoveredBatiment = null;

        this.stairsData = null;
        this.flatsData = null;

        this.turnImages = [];
        this.currentFrame = 0;
        this.currentStair = null;
        this.imagesPerLevel = 0;
        this.hasJustChanged = false;

        this.selectedBatiment = null;
        this.selectedAppart = null;
        this.showAppartDetails = false;
        this.zoomLevel = 100;

        this.params = null;
        this.autoRotate = false
        this.allowMoveCanvas = false;
        this.textLeftOffset =0;

        this.arianeLevel = 0;

        this.isLoading = true;
        this.loadPercent = 0;
        this.batLoaded = 0;

        this.ready = false;
        this.sliderData = null;

        this.dpi = null;
        this.showThree = false;
        this.fromURL = false;


        this.threeScene = null;
        this.currentURL = null;

        this.visits = null;



        //internalThis = this;
    }

    setData(){
        $.getJSON("data/visit.json", (data) => {
            this.visits = data;
            $.getJSON("data/data.json",(data)=>{
                this.jsonData= data;
                $.getJSON("data/params.json",(json)=>{
                    this.params= json;
                    this.preloader();
                });            
            });
        });
    }

    init(){
        this.currentURL = window.location.href;
        var redirect = this.currentURL.indexOf("type=")

        if(redirect > -1){
            var visitType = this.currentURL.substr(redirect+5,1);
            this.fromURL = true;
            this.showAppartDetails = true;
            this.arianeLevel = 2; 
            this.showThree = true;   

            var found = undefined;

            for(var batId = 0; batId < this.jsonData.AppartsCoords.length; batId++){
                //console.log("check batID", batId);
                if(found != undefined)
                    break;
                for(var frameId = 0; frameId < this.jsonData.AppartsCoords[batId].appartsAtFrame.length; frameId++){
                    //console.log("check frameID", frameId);
                    var _frame = this.jsonData.AppartsCoords[batId].appartsAtFrame[frameId];
                    if(_frame != null && _frame.apparts.length > 0){
                        found = _frame.apparts.find(x=> x.nbp == visitType && x.sphereID != null);
                        if(found != undefined){
                            console.log("found", found);
                            this.showThree = true;
                            this.selectedAppart = found;
                            this.selectedBatiment = batId;
                            this.currentFrame = frameId;
                            break;
                            //this.jsonData.AppartsCoords[this.selectedBatiment].appartsAtFrame[this.currentFrame].apparts.
                        }
                    }
                }
            }
        }


        this.dpi= window.devicePixelRatio || 1;

        this.initQuarter();

        window.addEventListener("resize", ()=> {this.windowresize()} );
        document.addEventListener("mouseup", ()=> {this.setLeftMouseButton(false)});
        document.addEventListener("mousedown", ()=>  {this.setLeftMouseButton(true)});

        this.windowresize();
    }

    shortcutLink(id){
        window.location.replace(this.currentURL + '?type=' + id);
    }

    returnToHome(){
        var newURL = this.currentURL.substr(0, this.currentURL.indexOf('?'));
        window.location.replace(newURL);
    }

    initQuarter(){

        if(this.selectedBatiment != null){
            this.initBatiment();
            return;
        }

        if(this.jsonData.AppartsCoords.length == 1){ //version sans vue quartier
            this.selectedBatiment = 0;
            console.log("ici")
            setTimeout(() => {
                this.initBatiment();
            }, 150);
        }
        else{
            console.log("la")
            this.quaterCanvas = $("#overlay")[0];
            this.quaterContext = this.quaterCanvas.getContext('2d');
    
            this.quaterContext.canvas.width = $("#image")[0].clientWidth;
            this.quaterContext.canvas.height = $("#image")[0].clientHeight;
    
            this.quaterCanvas.width = $("#image")[0].clientWidth;
            this.quaterCanvas.height = $("#image")[0].clientWidth;
    
            this.quarterOverlay = $("#overlayForHover")[0];
            this.overlayContext = this.quarterOverlay.getContext('2d');
    
            this.overlayContext.canvas.width = $("#image")[0].clientWidth;
            this.overlayContext.canvas.height = $("#image")[0].clientHeight;
    
            this.quarterOverlay.width = $("#image")[0].clientWidth;
            this.quarterOverlay.height = $("#image")[0].clientWidth;        
    
            this.quaterCanvas.removeEventListener('mousemove',(e)=>{this.quarterOverlap(e)});
            this.quaterCanvas.removeEventListener('click',()=>{this.quarterBat()});      
            this.quaterCanvas.removeEventListener("wheel", (event)=> {this.setZoomQuarter(event)});   
    
            var img_overlay = new Image();
            img_overlay.src = './img/quartier/overlay.jpg';
            img_overlay.onload = (() =>{
                this.quaterContext.drawImage(img_overlay,0,0,this.quaterCanvas.clientWidth, this.quaterCanvas.clientHeight );
                this.quaterCanvas.addEventListener('mousemove',(e)=>{this.quarterOverlap(e)});
                this.quaterCanvas.addEventListener('click',()=>{this.quarterBat()});
                this.quaterCanvas.addEventListener("wheel", (event)=> {this.setZoomQuarter(event)});             
            });
        }

    }

    quarterBat(){
        //console.log("mouse click over quarter canvas")
        var test = this.quaterContext.getImageData(this.mouseX,this.mouseY,1,1).data ;

        for(var i =0; i < 3; i++){
            if(test[i] < 10)
                test[i] = 0;
            if(test[i] > 250)
                test[i] = 255
        }
        var found = this.params.batiments.find(x => x.color[0] == test[0] && x.color[1] == test[1] && x.color[2] == test[2] );
        if(found == undefined){
            this.selectedBatiment = null;
        }
        else{
            this.selectedBatiment = found.id;
            console.log("bat found : " + this.selectedBatiment);
            this.arianeLevel = 1;
            setTimeout(() => {
                this.initBatiment();
            }, 150);
            
        }
    }

    quarterOverlap(event){
        //console.log("mouse move over quarter canvas");
        var eventX = event.clientX == undefined ? event.touches[0].clientX : event.clientX;
        var eventY = event.clientY == undefined ? event.touches[0].clientY : event.clientY;   
       
        var quarterRect = this.quaterCanvas.getBoundingClientRect();

        var x = (eventX - quarterRect.left ) ;
        var y = (eventY - quarterRect.top) ; 
        this.mouseX = x / this.zoomLevel * 100;
        this.mouseY = y / this.zoomLevel * 100;  
        console.log("this.mouseX", this.mouseX);
        console.log("this.mouseY", this.mouseY);
        console.log("zoom", this.zoomLevel);
       
        var test = this.quaterContext.getImageData(this.mouseX,this.mouseY,1,1).data ;

        for(var i =0; i < 3; i++){
            if(test[i] < 10)
                test[i] = 0;
            if(test[i] > 245)
                test[i] = 255
        }  

        var sameColor = (this.hoveredColor!= null && this.hoveredColor[0] == test[0] && this.hoveredColor[1] == test[1] && this.hoveredColor[2] == test[2]);
        
        if (!sameColor){
            this.hoveredColor = [test[0], test[1], test[2]];
            //console.log("color", this.hoveredColor);
            var imageData = this.quaterContext.getImageData(0,0,quarterRect.width / this.zoomLevel * 100 , quarterRect.height / this.zoomLevel * 100);
            var data = imageData.data;            
            if (this.hoveredColor[0] != 0 ||  this.hoveredColor[1] != 0 || this.hoveredColor[2] != 0 ){
                this.quaterCanvas.style.cursor = "pointer";
                for ( i = 0; i < data.length ; i+=4){
                    if(Math.abs(data[i] - test[0]) < 10 &&
                        Math.abs(data[i+1] - test[1]) < 10 &&
                        Math.abs(data[i+2] - test[2]) < 10
                    ){
                        data[i] = 61;
                        data[i+1] = 173;
                        data[i+2] = 50; 
                        data[i+3] = 153;
                        //61,173,50
                    }
                    else{
                        data[i+3] = 0;
                    }
                }
            }
            else{
                this.quaterCanvas.style.cursor = "default";
                for ( i = 0; i < data.length ; i+=4){
                    data[i+3] = 0;
                }
            }
            this.overlayContext.putImageData(imageData,0,0);

            var found = this.params.batiments.find(x => x.color[0] == this.hoveredColor[0] && x.color[1] == this.hoveredColor[1] && x.color[2] == this.hoveredColor[2] );
            if(found == undefined){
                this.hoveredBatiment = null;
            }
            else{
                this.hoveredBatiment = found.id;
            }            
        }
    }

    initBatiment(){
        console.log("initbatiment");
        console.log("this.selectedBatiment",this.selectedBatiment);
        console.log("this.jsonData",this.jsonData);
        this.imagesPerLevel = this.jsonData.AppartsCoords[this.selectedBatiment].framesByLevel;
        this.currentFrame = this.jsonData.AppartsCoords[this.selectedBatiment].fromFrame;

        this.canvas = $("#batCanvas")[0];

        this.canvasWidth = $("#backgroundDiv")[0].clientWidth * (this.zoomLevel / 100);
        this.canvasHeight = $("#backgroundDiv")[0].clientHeight * (this.zoomLevel / 100);

        this.context = this.canvas.getContext('2d');
        console.log("context set", this.context);

        this.canvas.width = this.canvasWidth;
        this.canvas.height = this.canvasHeight;      

        this.stairsData = this.makeStairsData();
        this.flatsData = this.makeFlatsData();

        this.canvas.removeEventListener("mousemove", (event) => { this.movingMouse(event) });
        this.canvas.removeEventListener("touchmove", (event) => { this.movingMouse(event) });
        this.canvas.removeEventListener("wheel", (event)=> {this.setZoomLevel(event)});
        this.canvas.removeEventListener("touchstart", (event)=>  {this.setLeftMouseButton(true); this.movingMouse(event, true)});
        this.canvas.removeEventListener("touchend", ()=>  {this.setLeftMouseButton(false)});

        this.canvas.addEventListener("mousemove", (event) => { this.movingMouse(event) });
        this.canvas.addEventListener("touchmove", (event) => { this.movingMouse(event) });
        this.canvas.addEventListener("wheel", (event)=> {this.setZoomLevel(event)});
        this.canvas.addEventListener("touchstart", (event)=>  {this.setLeftMouseButton(true); this.movingMouse(event, true)});
        this.canvas.addEventListener("touchend", ()=>  {this.setLeftMouseButton(false)});

        
        this.imageChange(this.currentFrame);    
        this.windowresize(); 
    }



    preloader(next=null){
        var start = this.jsonData.AppartsCoords[0].fromFrame;
        var end = this.jsonData.AppartsCoords[this.jsonData.AppartsCoords.length - 1].toFrame;
        this.currentFrame = start;

        if (next == null)
            this.preloadImages(start);
        else{
            this.loadPercent = next / end;
            if(next> end){
                this.ready = true;
                this.init();
                return;
            }
            else{
                this.preloadImages(next);
            }
        }
    }


    preloadImages(index){
        var image = new Image();
        var image_name = "0000000000000000" + index;
        image_name = image_name.substr(image_name.length - this.params.imageTurnCounterLength);
        var image_path = "img/turn/" + this.params.imageTurnPrefix + image_name + ".jpg";        
        image.src = image_path;
        $("#backgroundDiv").css("background", "url("+ image_path +") no-repeat center center");
        this.turnImages.push(image);
        image.onload = this.preloader(++index); 
    }

    setZoomLevel(event){
        var delta = Math.sign(event.deltaY);
        if (delta > 0){
            this.zoomLevel = Math.max(50, this.zoomLevel - this.params.zoomStep);
        }
        else{
            this.zoomLevel = Math.min(150, this.zoomLevel + this.params.zoomStep);
        }
        this.imageChange(this.currentFrame);
    }

    setZoomQuarter(event){
        var delta = Math.sign(event.deltaY);
        if (delta > 0){
            this.zoomLevel = Math.max(50, this.zoomLevel - this.params.zoomStep);
        }
        else{
            this.zoomLevel = Math.min(150, this.zoomLevel + this.params.zoomStep);
        }        
        $("#image").css("transform", "scale(" + this.zoomLevel /100 + ")" );
        $("#overlay").css("transform", "scale(" + this.zoomLevel /100 + ")" );
        $("#overlayForHover").css("transform", "scale(" + this.zoomLevel /100 + ")" );
    }

    setAutoRotate(){
        if(this.autoRotate){
            setTimeout(() => {
                this.changeImage(1);
                this.setAutoRotate();
            }, 800);
        }
    }

    setLeftMouseButton(state){
        this.leftMouseButtonDown = state;
    }

    windowresize(){
        setTimeout(() => {
            this.resize();
            $("#batCanvas").css("top", "-" + $("#backgroundDiv")[0].clientHeight + "px");

                //this.imageChange(this.currentFrame,true);

            /*
            if(this.selectedBatiment != null){
                if( $("#backgroundDiv")[0].clientHeight > 0)
                    $("#batCanvas").css("top", "-" + $("#backgroundDiv")[0].clientHeight + "px");
                else
                    $("#batCanvas").css("top", "-" + $("#backgroundDiv")[0].clientHeight + "px");
                this.imageChange(this.currentFrame,true); 
            }      */
        }, 150);
        
    }

    resize(){
        if(this.selectedBatiment != null){
            this.context.clearRect(0,0,this.canvasWidth,this.canvasHeight);
            var rect = this.canvas.getBoundingClientRect();
    
            if($("#backgroundDiv")[0].clientWidth > 0){
                this.canvasWidth = $("#backgroundDiv")[0].clientWidth * (this.zoomLevel / 100);
                this.canvasHeight = $("#backgroundDiv")[0].clientHeight * (this.zoomLevel / 100);
        /*
                this.canvasLeft = $("#backgroundDiv")[0].offsetLeft + ($("#backgroundDiv")[0].clientWidth * (1-(this.zoomLevel/100)))/2;
                this.canvasTop = $("#backgroundDiv")[0].offsetTop + ($("#backgroundDiv")[0].clientHeight * (1-(this.zoomLevel/100)))/2;
    */
                this.canvasLeft = rect.left;
                this.canvasTop = rect.top;
            }
            else{
                this.canvasWidth = $("#containerDiv")[0].clientWidth * (this.zoomLevel / 100);
                this.canvasHeight = $("#containerDiv")[0].clientHeight * (this.zoomLevel / 100);
        
                this.canvasLeft = ($("#containerDiv")[0].clientWidth * (1-(this.zoomLevel/100)))/2;
                this.canvasTop = ($("#containerDiv")[0].clientHeight * (1-(this.zoomLevel/100)))/2;            
            }
            this.canvas.width = this.canvasWidth ; //rect.width * this.dpi; //
            this.canvas.height = this.canvasHeight; //rect.height * this.dpi; //this.canvasHeight;
            //this.context.scale(this.dpi, this.dpi);
            //this.canvas.style.width = this.canvasWidth;
            //this.canvas.style.height = this.canvasHeight ;  
            this.context.clearRect(0,0,this.canvasWidth,this.canvasHeight);

        }
        else{
            this.initQuarter();
        }
    }

    imageChange(imageNumber, getoverlap = true){
        this.resize();
        this.currentFrame = imageNumber;
        $("#backgroundDiv").css("background", "url("+ this.turnImages[imageNumber].src +") no-repeat center center");
        $("#backgroundDiv").css("background-size", "100% 100% ");
        if(this.params.boussole)
            this.getCompassRotation();
        $("#drawingDiv").css("transform", "scale(" + this.zoomLevel /100 + ")" );
        this.getStairData(imageNumber, getoverlap);
    } 

    getCompassRotation(){
        var oriRot = this.jsonData.AppartsCoords[this.selectedBatiment].northDecay;
        var deltaRot = this.jsonData.AppartsCoords[this.selectedBatiment].framesByLevel;
        var currentRot = oriRot + (this.currentFrame%deltaRot) * (360 / deltaRot);
        $("#compass").css("transform", "rotateZ(" + currentRot+"deg)");
    }

    changeImage(sens){
        if(this.imagesPerLevel > 1){
            this.currentFrame++ ; // plus simple pour les modulo
            if (sens < 0){
                this.currentFrame--;
                var tmpPos = this.stairsData.find(x=> x.id == this.currentStair).pos
                var stairMultiplier = tmpPos == null ? 0 : tmpPos;
                this.currentFrame = Math.min(this.imagesPerLevel * (stairMultiplier + 1), this.currentFrame);
                if (this.currentFrame % this.imagesPerLevel == 0)
                    this.currentFrame += this.imagesPerLevel ; 
            }
            else{
                if (this.currentFrame % this.imagesPerLevel == 0)
                    this.currentFrame -= this.imagesPerLevel ;
                this.currentFrame++;
                this.currentFrame = Math.max(1, this.currentFrame);
            }
            this.currentFrame--; // plus simple pour les modulo
            this.imageChange(this.currentFrame); 
        }   
    }
    
    getStairData(frameNumber, getoverlap= true){
        var startImage = this.jsonData.AppartsCoords[this.selectedBatiment].fromFrame;
        this.context.clearRect(0,0,this.canvasWidth,this.canvasHeight);
        var allowedTypes = [];
        this.flatsData.forEach(elem =>{
            if(elem.check && !allowedTypes.includes(elem.id))
                allowedTypes.push(elem.id);
        });
        //console.log("allowedTypes", allowedTypes)
        this.jsonData.AppartsCoords[this.selectedBatiment].appartsAtFrame[frameNumber - startImage].apparts.forEach(appart => {
            //console.log("check type", appart.nbp);
            if(allowedTypes.includes(appart.nbp)){
               // console.log("ok", appart.appartCoords);
               var color = appart.ksos ? 'rgba(50,50,50,.4)' : this.params.unselectedColor

                this.colorize(appart.appartCoords.lignesCoord[0], color);
            }
                
        });  
        if(getoverlap)
            this.isOverlappingAppart();   
    }

    movingMouse(event, mobile=false){
        var eventX, eventY;

        eventX = event.clientX == undefined ? event.touches[0].clientX : event.clientX;
        eventY = event.clientY == undefined ? event.touches[0].clientY : event.clientY;        
        if(this.leftMouseButtonDown &&!mobile){
            if(this.allowMoveCanvas){
                $("#containerDiv")[0].style.top = $("#containerDiv")[0].offsetTop - this.mouseY + eventY + "px";
                $("#containerDiv")[0].style.left =  $("#containerDiv")[0].offsetLeft - this.mouseX + eventX + "px";
                this.resize();
            }
            else{
                if(this.hasJustChanged)
                    return;  
                var deltaX = this.mouseX - eventX;
                this.changeImage(deltaX);
                this.hasJustChanged = true;
                setTimeout(() => {
                    this.hasJustChanged = false;
                }, this.params.changingImageDelay); 
            }
        }
        else
        {
            this.isOverlappingAppart();
        }
        this.mouseX = eventX;
        this.mouseY = eventY;
    }

    clickOnAppart(){
        if (this.selectedAppart != null){
            this.showAppartDetails = true;
            this.arianeLevel++;// = 1; // ++ ? 
        }
    }

    isOverlappingAppart(reset=true){
        if(this.fromURL)
            return;
        var x = (this.mouseX - this.canvasLeft) / this.canvasWidth  ;
        var y = (this.mouseY - this.canvasTop) / this.canvasHeight ;  

        this.context.clearRect(0,0,this.canvasWidth,this.canvasHeight);

        var allowedTypes = [];
        //console.log("flatsDataDebug", this.flatsData);
        this.flatsData.forEach(elem =>{
            if(elem.check)
                allowedTypes.push(elem.id);
        });       
        if(reset){
            this.selectedAppart = null
        }
         
        var startImage = this.jsonData.AppartsCoords[this.selectedBatiment].fromFrame;

        if(this.jsonData.AppartsCoords[this.selectedBatiment].appartsAtFrame[this.currentFrame - startImage].apparts.length > 0){
            this.jsonData.AppartsCoords[this.selectedBatiment].appartsAtFrame[this.currentFrame - startImage].apparts.forEach(appart => {

                if(allowedTypes.includes(appart.nbp)){
                    var array = appart.appartCoords.lignesCoord[0];
                    var isinside = this.contains(array, y,x);

                    var selectedColor = appart.ksos ? 'rgba(50,50,50,.8)' : this.params.selectedColor
                    var unselectedColor = appart.ksos ? 'rgba(50,50,50,.4)' : this.params.unselectedColor
            
                    if(isinside){
                        this.selectedAppart = appart;
                        this.colorize(appart.appartCoords.lignesCoord[0], selectedColor);
                    }
                    else{
                        this.colorize(appart.appartCoords.lignesCoord[0], unselectedColor);
                    }

                    var shadowOffset;
                    var font_size;
                    if (this.canvasWidth < 800){
                        shadowOffset = .002;
                        font_size = '.5em';
                    }
                    else{
                        shadowOffset = .0008;
                        font_size = '.8em';
                    }
 
                    this.context.beginPath();
                    this.context.fillStyle = "#000";
                    this.context.font =  font_size + ' Comfortaa';

                    var textToDisplay = appart.appartName;

                    if(this.visits.spheres[appart.sphereID] != undefined && appart.appartID == this.visits.spheres[appart.sphereID].AppID){
                        textToDisplay = "■ " + textToDisplay;
                    }

                    this.textLeftOffset = this.context.measureText(textToDisplay).width /2;
                    this.context.fillText(textToDisplay, (appart.appartCoords.center[0] + shadowOffset) * this.canvasWidth - this.textLeftOffset,  (appart.appartCoords.center[1] +shadowOffset) * this.canvasHeight);
                    this.context.fillStyle = "#fff";
                    this.context.fillText(textToDisplay, appart.appartCoords.center[0] * this.canvasWidth  - this.textLeftOffset,  appart.appartCoords.center[1] * this.canvasHeight);

                    this.context.closePath();
                }
            });
        }           
    }


    downGradeArianeLevel(buttonIndex){
        var decal = this.jsonData.AppartsCoords.length == 1 ? 1 : 0 ;
        while(this.arianeLevel + decal > buttonIndex  ){
            switch (this.arianeLevel + decal) {
                case 1:
                    this.selectedBatiment = null;
                    this.currentStair = null;
                    this.selectedAppart = null;
                    this.zoomLevel = 100;

                    setTimeout(() => {
                        this.initQuarter();
                    }, 150);
                    break;
                case 2:
                    this.showAppartDetails = false;
                    this.selectedAppart = null;
                    this.windowresize();
                    break;
            
                default:
                    console.log('downgradeAriane problem')
                    break;
            }
            this.arianeLevel--;
        }
        this.arianeLevel += decal;
    }

    colorize(points, color){
        this.context.fillStyle = color;
        this.context.beginPath();
        var firstPoint = true;
        points.forEach(point => {
            if (firstPoint){
                this.context.moveTo(point[0]* this.canvasWidth , point[1]* this.canvasHeight ) ;
                firstPoint = false;
            }else{
                this.context.lineTo(point[0]* this.canvasWidth  , point[1]* this.canvasHeight );
            }
        });
        this.context.closePath();
        this.context.fill();
    }

    makeFlatsData(){
        var steps = this.jsonData.AppartsCoords[this.selectedBatiment].framesByLevel;
        var min = this.jsonData.AppartsCoords[this.selectedBatiment].fromFrame;   
        var max = this.jsonData.AppartsCoords[this.selectedBatiment].toFrame;
        var array = [];
        for(var i =0; i < max - min; i+= steps){
            var found;
            //console.log("makeFlatsData", i);
            //console.log("makeFlatsData 2", this.jsonData.AppartsCoords[this.selectedBatiment]);
            this.jsonData.AppartsCoords[this.selectedBatiment].appartsAtFrame[i].apparts.forEach(appart => {
                found = array.findIndex(x=>x.id == appart.nbp);
                if(found == -1){
                    var entry = {
                        id: appart.nbp,
                        ori: appart.type, 
                        name:"",
                        count: 1,
                        check: true
                    }
                    
                    array.push(entry); 
                }
                else{
                    array[found].count++;
                }
            });
        }

        array.sort(this.comparaison2);
        array.forEach(elem =>{
            elem.name = elem.id + " pièces";
        })    
        //console.log("makeFlatsData return",array);
        this.makeSlider(array);
        return array;        
    }

    makeSlider(array){
        //console.log("makeSlider", array);
        if(this.ready && this.selectedBatiment != null){
            var sliderMin = Number(array[0].id);
            var sliderMax = Number(
                array[array.length - 1].id
            );
            //console.log("min", sliderMin);
            //console.log('max', sliderMax);
    
            this.sliderData = {
                min: sliderMin,
                max: sliderMax, 
                value: [sliderMin, sliderMax]
            } 
        }
        else{
            this.sliderData = null;
        }

    }

    makeStairsData(){
        var steps = this.jsonData.AppartsCoords[this.selectedBatiment].framesByLevel;
        var min = this.jsonData.AppartsCoords[this.selectedBatiment].fromFrame;   
        var max = this.jsonData.AppartsCoords[this.selectedBatiment].toFrame;

        var array = [];
        var posInArray = 0;

        for(var i =min; i <= max; i+= steps){
            var entry = {
                id: null,
                name: "",
                pos: posInArray
            }
            //console.log("makeStairsData", i)
            //console.log("makeStairsData 2 ", this.jsonData.AppartsCoords[this.selectedBatiment])
            if(this.jsonData.AppartsCoords[this.selectedBatiment].appartsAtFrame[i -min].apparts.length==0){
                entry.name = "Vue d'ensemble";
            }
            else {
                entry.id = this.jsonData.AppartsCoords[this.selectedBatiment].appartsAtFrame[i- min].apparts[0].appartLevel;
                switch (entry.id){
                    case 0:
                        entry.name = "Rez-de-chaussée";
                    break;
                    case 1:
                        entry.name = "1er étage";
                    break;
                    default:
                        entry.name =  entry.id + "ème étage";
                    break;
                }
            }         
            array.push(entry);
            posInArray++;
        }
        array.sort(this.comparaison);
        if(this.params.flatsOnRoof)
        {
            array[1].name = "Toit";
        }
        //console.log("makeStairsData return", array);
        return array;
    }

    comparaison(a,b){
        if(b.id == null)
            return 1;
        if(a.id == null)
            return -1;
        return b.id - a.id;
    }   

    comparaison2(a,b){
        if(a.id == null)
            return 1;
        if(b.id == null)
            return -1;
        return a.id - b.id;
    } 
  
    setPopup(){  
        setTimeout(() => {
            if(this.selectedAppart == null)
                return;            
            var popupElement = $('#popup');
            popupElement.css("left", this.canvasLeft - this.textLeftOffset/2 + this.selectedAppart.appartCoords.center[0] * this.canvasWidth - popupElement[0].clientWidth /2) ;
            
            if(this.selectedAppart.appartCoords.center[1] > .5 ){
                popupElement[0].classList.add("beside");
                popupElement.css("top", this.selectedAppart.appartCoords.center[1] * this.canvasHeight - popupElement[0].clientHeight + this.canvasTop - 20 + "px");
            }
            else{
                popupElement[0].classList.remove("beside");
                popupElement.css("top", this.selectedAppart.appartCoords.center[1]* this.canvasHeight + this.canvasTop + 10 + "px" );
            }           
        },50);
    }


    /**
     * @return {boolean} true if (lng, lat) is in bounds
     */
    contains(bounds, lat, lng) {
        //https://rosettacode.org/wiki/Ray-casting_algorithm
        var count = 0;
        for (var b = 0; b < bounds.length; b++) {
            var vertex1 = bounds[b];
            var vertex2 = bounds[(b + 1) % bounds.length];
            if (this.west(vertex1, vertex2, lng, lat))
                ++count;
        }
        return count % 2;
    }

    /**
     * @return {boolean} true if (x,y) is west of the line segment connecting A and B
     */
    west(A, B, x, y) {
        if (A[1] <= B[1]) {
            if (y <= A[1] || y > B[1] ||
                x >= A[0] && x >= B[0]) {
                return false;
            } else if (x < A[0] && x < B[0]) {
                return true;
            } else {
                return (y - A[1]) / (x - A[0]) > (B[1] - A[1]) / (B[0] - A[0]);
            }
        } else {
            return this.west(B, A, x, y);
        }
    }

    log(title,value){
        console.log(title,value);
    }

}